import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilMasks } from 'src/app/utils/util-masks';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { UtilForms } from 'src/app/utils/util-forms';
import { EnderecoService } from 'src/app/services/http/endereco.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUploadLoteComponent } from '../modal-upload-lote/modal-upload-lote.component';
import { HgService } from 'src/app/services/http/hg.service';
import * as moment from "moment";

@Component({
  selector: 'app-form-agendamento-laudo-union',
  templateUrl: './form-agendamento-laudo-union.component.html',
  styleUrls: ['./form-agendamento-laudo-union.component.scss']
})
export class FormAgendamentoLaudoUnionComponent implements OnInit {


  formAgendamento = new FormGroup({
    dataAgendamento: new FormControl('', [Validators.required]),
    // hora: new FormControl('', []),
    periodo: new FormControl('', [Validators.required])
  });

  formEndereco = new FormGroup({
    numero: new FormControl('', [Validators.required]),
    logradouro: new FormControl('', [Validators.required]),
    cidade: new FormControl('', [Validators.required]),
    uf: new FormControl('', [Validators.required]),
    cep: new FormControl('', [Validators.required, Validators.minLength(10)]),
    bairro: new FormControl('', [Validators.required]),
    complemento: new FormControl('', []),
    referencia: new FormControl('', []),
  });

  formVeiculo = new FormGroup({
    placa: new FormControl('', [Validators.required, Validators.minLength(7)]),
    chassi: new FormControl('', [Validators.required, Validators.minLength(7)]),
    anoFab: new FormControl('', [Validators.required]),
    anoMod: new FormControl('', [Validators.required]),
    marca: new FormControl('', [Validators.required]),
    modelo: new FormControl('', [Validators.required]),
    ufPlaca: new FormControl('', [Validators.required]),
  });

  formVistoria = new FormGroup({
    cliente: new FormControl('', [Validators.required]),
    unidadeRealizadora: new FormControl('', [Validators.required]),
    tipolaudo: new FormControl({value: '', disabled: true}, [Validators.required]),
    vistoriador: new FormControl({value: '', disabled: true}, [Validators.required])
  });

  form = new FormGroup({
    agendamento: this.formAgendamento,
    endereco: this.formEndereco,
    vistoria: this.formVistoria,
    veiculo: this.formVeiculo,
  });

  errorMessage: string = '';

  mask = {
    data: { mask: UtilMasks.dataBr, guide: false},
    placa: { mask: UtilMasks.placa, guide: false },
    cep: { mask: UtilMasks.cep, guide: false },
    hora: { mask: UtilMasks.horario, guide: false },
  }

  ufOptions = UtilForms.optionsEstado.nome;

  dataInicioAgendamento;

  $unsub = new Subscription();
  listaUnidades: any[] = [];
  listaClientes: any[] = [];
  listaTipoLaudo: any[] = [];
  listaVistoriador: any[] =[];

  // integraçãoHg variaveis
  desejaIntegrar: boolean = false;
  stateOptions: any[] = [
    { label: "Não", desejaIntegrar: false },
    { label: "Sim", desejaIntegrar: true },
  ];
  tokenHg: string = null;
  refreshTokenHg: string = null;
  entityHgId: string = null;
  instanceHgId: string = null;
  userHgId: string = null;
  emailHg: string = null;
  senhaHg: string = null;
  isAutenticadoHg: boolean = false;
  dadosIniciaisHg: any = null;
  desabilitaCriar: boolean = false;
  idConsulta: any;

   @Output() formSubmit = new EventEmitter();

  constructor(private _hgService: HgService, private modalService: NgbModal, private laudoService: LaudoUnionService, private enderecoService: EnderecoService, private router: Router, private msgService: ModalMsgService, private _msgService: ModalMsgService) {

    this.$unsub.add(this.setStateTipoLaudo());
    this.$unsub.add(this.pesquisaCep());
    this.$unsub.add(this.pesquisaTipoLaudoCliente());
    this.laudoService.getListaUnidades().then( r => this.listaUnidades = r );
    this.laudoService.getListaClientes().then( r => this.listaClientes = r );

    let dataAtual = new Date();
    this.dataInicioAgendamento = {
      day: dataAtual.getDate(),
      month: dataAtual.getMonth()+1,
      year: dataAtual.getFullYear(),
    };
  }

  ngOnInit() {
  }

  pesquisaCep() {
    return this.formEndereco.controls.cep.valueChanges.pipe(filter(v => v.length==10), debounceTime(400), distinctUntilChanged()).subscribe(r => {
      this.enderecoService.pesquisaCEP(r).then(e => {
        this.formEndereco.patchValue({
          bairro: e.bairro,
          logradouro: e.rua,
          uf: e.estado,
          complemento: e.complemento,
          cidade: e.cidade
        });
      }).catch( e => console.error(e) );
    });
  }

  pesquisaTipoLaudoCliente() {
    return this.formVistoria.controls.cliente.valueChanges.pipe(filter(v => v !== ''), debounceTime(400), distinctUntilChanged()).subscribe(v => {
      this.laudoService.getListaTipoLaudoCliente(v).then(r => this.listaTipoLaudo = r );
    })
  }

  pesquisaVistoriador(){
    let id = this.formVistoria.value.unidadeRealizadora;
    if (id) {
      this.laudoService.getListaVistoriador(id).then(r => {
        this.listaVistoriador = r;
        if (this.listaVistoriador.length > 0) {
          this.formVistoria.controls.vistoriador.enable();
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Unidade sem vistoriador cadastrado.';
        }
      });
    } else {
      this.formVistoria.controls.vistoriador.disable();
      this.errorMessage = '';
    }
  }

  setStateTipoLaudo() {
    return this.formVistoria.controls.cliente.valueChanges.subscribe(r => {
      if(r == '') {
        this.formVistoria.controls.tipolaudo.disable();
        this.formVistoria.controls.tipolaudo.patchValue('');
      } else {
        this.formVistoria.controls.tipolaudo.enable();
      }
    });
  }

  ngOnDestroy() {
    this.$unsub.unsubscribe();
  }

  formatDate(date) {
    return new Date(
      date.year,
      date.month - 1,
      date.day,
      0, 0, 0, 0
    ).toISOString();
  }

  pesquisaVeiculo(controlName) {
    this.laudoService.getVeiculoPlacaChassi(this.formVeiculo.get(controlName).value).then(r => {
      this.formVeiculo.patchValue({...r});
    }).catch(r => console.error('erro', r));
  }

  salvar() {

    if(this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    } else {
      this.formSubmit.emit(this.form.value);

      if (this.desejaIntegrar) {
        this.dadosIniciaisHg = {
          tokenHg: this.tokenHg,
          refreshTokenHg: this.refreshTokenHg,
          entityHgId: this.entityHgId,
          instanceHgId: this.instanceHgId,
          userHgId: this.userHgId,
          emailHg: this.emailHg,
          senhaHg: this.senhaHg,
        };
      } else this.dadosIniciaisHg = null;
    }

    let jsonData = {
      ...this.formVistoria.value,
      cliente: parseInt(this.formVistoria.value.cliente),
      clienteAvulso: (this.formVistoria.value.cliente == 0),
      endereco: {...this.formEndereco.value},
      veiculo: {...this.formVeiculo.value},
      dataCriacao: new Date().toISOString(),
      dataAgendamento: this.formatDate(this.formAgendamento.value.dataAgendamento),
      tipolaudo: parseInt(this.formVistoria.controls.tipolaudo.value),
      modulo: '',
      periodo: parseInt(this.formAgendamento.controls.periodo.value),
      telefone1: '',
      telefone2: '',
      telefone3: '',
      unidade: '',
      unidadeRealizadora: parseInt(this.formVistoria.value.unidadeRealizadora),
      vistoriador: parseInt(this.formVistoria.value.vistoriador),
      hg: this.dadosIniciaisHg
    }

    console.log('jsonData : ', jsonData)

    this.laudoService.salvarAgendamento(jsonData).then(r => {
      if( r['status'] ){
        this.msgService.openDialog(r['msg'], '', 'success');
        this.router.navigate(['laudo', 'agendamentos', 'listar'], {queryParams : { status: '2' }});
      }else
        this.msgService.openDialog(r['msg'], '', 'warning');
    }).catch(e => {
      this.msgService.openDialog('Erro ao agendar laudo', '', 'danger');
    });
  }

  agendamentoPorLote() {
    this.modalService.open(ModalUploadLoteComponent, { centered: true });
  }

  // integração Hg functions
  desejaIntegrarHg() {
    this.desabilitaCriar = this.desejaIntegrar;
  }

  authHg(email, senha) {
    this._hgService
      .autenticarHg(email, senha)
      .then((dadosAuth) => {
        this.tokenHg = dadosAuth?.auth?.token;
        this.refreshTokenHg = dadosAuth?.auth?.refreshToken;
        this.entityHgId = dadosAuth?.entity?.id;
        this.instanceHgId = dadosAuth?.instance?.id;
        this.userHgId = dadosAuth?.user?.id;
        this.emailHg = email;
        this.senhaHg = senha;

        this._msgService.openDialog(
          `Sucesso!`,
          `Login efetuado com sucesso!`,
          "info"
        );

        this.isAutenticadoHg = true;
        this.desabilitaCriar = false;
        this.setStorageTokenHg();
      })
      .catch((e) => {
        localStorage.removeItem("hgDadosStorage");
        this.isAutenticadoHg = false;
        this.desabilitaCriar = true;
        this._msgService.openDialog(
          `Falha ao atenticar !`,
          `Tente novamente. Caso persista o erro, entre em contato com nosso suporte.`,
          "danger"
        );
      });
  }

  deslogar(){
    localStorage.removeItem("hgDadosStorage");
    this.isAutenticadoHg = false;
    this.desabilitaCriar = true;
    this.emailHg = '';
    this.senhaHg = '';
  }

  setStorageTokenHg() {
    localStorage.removeItem("hgDadosStorage");
    var now = moment();

    let hgDadosStorage = {
      tokenHg: this.tokenHg,
      createIn: now,
      entityHgId: this.entityHgId,
      instanceHgId: this.instanceHgId,
      userHgId: this.userHgId,
    };

    return;

    localStorage.setItem("hgDadosStorage", JSON.stringify(hgDadosStorage));
  }

}
